import { LocalDate } from '@js-joda/core';
import capturedResponses from './demoWeeklyEnergyBudgetResponses.json';
import { WeeklyEnergyBudget } from '../types';

type CapturedBudgetResponse = {
  request: { startDate: string };
  response: WeeklyEnergyBudget;
};

const CAPTURED: CapturedBudgetResponse[] = capturedResponses as unknown as CapturedBudgetResponse[];

const mondayOnOrBefore = (date: LocalDate): LocalDate => date.minusDays((date.dayOfWeek().value() - 1) % 7);

const DAYS_PER_WEEK = 7;

const budgetForWeek = (startDate: LocalDate, isCurrentWeekBudget: boolean): WeeklyEnergyBudget => {
  const weeksBack = Math.round(startDate.until(mondayOnOrBefore(LocalDate.now())).days() / DAYS_PER_WEEK);
  const index = Math.min(CAPTURED.length - 1, Math.max(0, weeksBack));
  const captured = CAPTURED[index];

  return {
    ...captured.response,
    startDate: startDate.toString(),
    endDate: startDate.plusDays(6).toString(),
    isCurrentWeekBudget,
    ...(isCurrentWeekBudget ? { pointsEarned: undefined, processed: false } : {}),
  };
};

export const getDemoCurrentWeekEnergyBudget = (): WeeklyEnergyBudget =>
  budgetForWeek(mondayOnOrBefore(LocalDate.now()), true);

export const getDemoWeekEnergyBudget = (startDate?: string): WeeklyEnergyBudget =>
  budgetForWeek(
    startDate ? mondayOnOrBefore(LocalDate.parse(startDate)) : mondayOnOrBefore(LocalDate.now()).minusDays(7),
    false,
  );
